<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="38.352"
    height="38.352"
    viewBox="0 0 38.352 38.352"
  >
    <path
      data-name="패스 112"
      d="m311.671 2734 4.764 14.648h14.427l-11.483 9.055 4.764 14.649-12.471-9.053-12.469 9.053 4.763-14.649-11.455-9.055h14.4z"
      transform="translate(-292.51 -2734)"
      style="fill:#0176f9"
    />
  </svg>
</template>
